import { Component, input } from '@angular/core';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-label-column',
    template: `
    <div class="vertical-column">
      <div class="row">
        <span class="vertical-text">{{'BFP.UI.' + resultType() | translate}}</span>
      </div>
    </div>
  `,
    styleUrl: './label-column.component.scss',
    imports: [TranslatePipe],
})
export class LabelColumnComponent {
  resultType = input<string>();
}
